export default function entry(title, value, args = {}) {
  return {title, value, ...args}
}
